import { useMemo } from 'react';

export default function PackageList(props) {

  const renderList = useMemo(() => {
    const { list = [], expressType = '' } = props;
    if (list.length) {
      return list.map(item => <dl className="list">
        <dt>{expressType === 'receive' ? '接收' : '邮寄'}时间：{item.date}</dt>
        <dd>
          <p>运单号：{item.expressNumber}</p>
          <p>快递公司：{item.expressCompany}</p>
          <p>备注：{item.remark}</p>
        </dd>
      </dl>)
    }
    return <p className="align-center" style={{ color: '#b9b9b9' }}>暂无数据</p>
  }, [props.list, props.expressType]);

  return renderList
}